export default "__VITE_ASSET__e4b8c59b__"